import { FC } from 'react';
import NormalComment from './NormalComment';
import ImpactComment from './ImpactComment';
import { TComment } from '../types';
import { TDocument, TDraft, TVersion } from '@modules/documents';
import { TFile, TFileVersion } from '@modules/files';
import { TResolvedItemsMap } from '@modules/items';
import { TPermissions } from '@modules/access';
import { TInlineBlock, TInlineBlockDraft, TInlineBlockVersion } from '@modules/inlineBlocks';

type SingleCommentProps = {
  comment: TComment;
  item: TDocument | TFile | TInlineBlock;
  version: TInlineBlockDraft | TDraft | TVersion | TFileVersion | TInlineBlockVersion;
  permissions: TPermissions;
  versionId: string;

  // Only needed for impact comments:
  resolvedItems: TResolvedItemsMap;
};

const SingleComment: FC<SingleCommentProps> = (props) => {
  const { comment } = props;
  if (comment.impact) return <ImpactComment {...props} />;
  return <NormalComment {...props} />;
};

export default SingleComment;
